module.exports={"Star Rating":"Hodnocení hvězdičkami","# star(s)":"{currentRating, plural, =1{# hvězdička} =5{# hvězdiček} other{# hvězdičky}}"};